import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=b0fa7b72&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0fa7b72')) {
      api.createRecord('b0fa7b72', component.options)
    } else {
      api.reload('b0fa7b72', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=b0fa7b72&", function () {
      api.rerender('b0fa7b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/Profile.vue"
export default component.exports